import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6y2fypfbxf: FaireBrandEntity = {
  token: "b_6y2fypfbxf",
  type: "brand",
  name: "A Gnome on the Roam",
  avatarUrl:
    "https://cdn.faire.com/fastly/bcf16f5d259f8983e4db46a7b5c29e7f8231990d3f7bf3c978f7d833cc613128.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ca8438b69f4aba60a857fff43ea8d1ba69d5cd79ef6c66befa41db13a040197b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/bcf16f5d259f8983e4db46a7b5c29e7f8231990d3f7bf3c978f7d833cc613128.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ca8438b69f4aba60a857fff43ea8d1ba69d5cd79ef6c66befa41db13a040197b.png",
  location: "West Frankfort, IL, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 121,
  isInsider: true,
  description:
    "I'm Valoree, the woman behind A Gnome on the Roam's wood signs, gnomes, and fake sweets.\nI rescue fabrics and sweaters from places like yard sales, thrift stores and estate sales in order to keep them out of landfills.\n\nOur homes, I believe, are sacred spaces that we curate with items that inspire. \nEvery piece is made with love and gratitude by my two hands, using locally sourced materials and environmentally sustainable processes. A house is a living, breathing compilation of your life experiences. Make your home a sanctuary by surrounding yourself with artifacts that express your story.\n\nMy aesthetic is both farmhouse and bohemian (farmhemian) a combination that has come about from being raised and currently living on our 8 generation farm in Southern Illinois. I take great pride in assuring you receive a quality product!\n\nGnome sweaters are upcylced an are one of a kind! This is why some of them are limited stock!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:58.387Z",
    importedBy: "entity-db-cli",
  },
};
